import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { isAiConsentProtectedRoute } from "../helpers/dossiers";
import { useAIConsent } from "../hooks/useAIConsent";
import { useAuth } from "../providers/AuthProvider";
import { User } from "../types/User";
import AIDisclaimerModal from "./modals/AIDisclamerModal";

const ProtectedRoute = ({
  me,
  children,
}: {
  me: User;
  children: JSX.Element;
}) => {
  const { getScopedPageUrl } = useAuth();

  const location = useLocation();
  const fullRedirectTarget = location.pathname + location.search;
  const encodedRedirectTo = encodeURIComponent(fullRedirectTarget);
  const { shouldPrompt: shouldPromptForAIConsent } = useAIConsent();
  const [showAIDisclaimer, setShowAIDisclaimer] = useState(
    shouldPromptForAIConsent && isAiConsentProtectedRoute()
  );

  if (!me?.initialSetupCompleted) {
    return (
      <Navigate
        to={`${getScopedPageUrl(
          "initialUser"
        )}?redirectTo=${encodedRedirectTo}`}
      />
    );
  }

  useEffect(() => {
    if (!shouldPromptForAIConsent) {
      setShowAIDisclaimer(false);
    } else if (isAiConsentProtectedRoute()) {
      setShowAIDisclaimer(true);
    }
  }, [shouldPromptForAIConsent]);

  return (
    <>
      {showAIDisclaimer ? (
        <AIDisclaimerModal
          isOpen={showAIDisclaimer}
          onClose={() => window.location.replace("/")}
          onConfirm={() => {}}
        />
      ) : (
        children
      )}
    </>
  );
};

export default ProtectedRoute;
